// Import model
import { DataviewObjectAppointmentResponse } from '../models/DataviewObjectAppointmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterObjectAppointmentRequest } from '../models/FilterObjectAppointmentRequest';
import { ObjectAppointment } from '../models/ObjectAppointment';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterObjectAppointmentRequestSerializer } from './FilterObjectAppointmentRequestSerializer';
import { ObjectAppointmentSerializer } from './ObjectAppointmentSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewObjectAppointmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewObjectAppointmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewObjectAppointmentResponse instance
   */
  static deserialize(json: string): DataviewObjectAppointmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewObjectAppointmentResponse instance
   */
  static fromObject(obj: any): DataviewObjectAppointmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewObjectAppointmentResponse');
    }


    const instance: DataviewObjectAppointmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ObjectAppointmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterObjectAppointmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewObjectAppointmentResponse instances
   */
  static deserializeArray(json: string): DataviewObjectAppointmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewObjectAppointmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewObjectAppointmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewObjectAppointmentResponse instance to a plain object
   */
  static toObject(instance: DataviewObjectAppointmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ObjectAppointmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterObjectAppointmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewObjectAppointmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewObjectAppointmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
